import React, {useState, useEffect} from "react";
import Paypal from "./Assets/paypalPaymentimg.png"
import CreditCard from "./Assets/CreditCardMethod.svg"
import GooglePay from "./Assets/GooglePayMethod.png"
import ApplePay from "./Assets/ApplePayMethod.png"
import BankTransfer from "./Assets/BankTransferMethod.svg"
import { useDispatch, useSelector } from "react-redux";
import { Elements, useStripe, useElements, CardElement, PaymentElement, PaymentRequestButtonElement } from "@stripe/react-stripe-js";
import { PaypalBtn } from "../Components/PaypalPayment/PaypalPayment";
import { BaseUrl } from "../../../../Actions/Base";
import { ApproveOrder } from "../Components/PaypalPayment/Helpers/CreateOrder";
import { SetLocalStorage, GetLocalStorage } from "../../../../Helpers/LocalStorage/LocalStorage";

const CoursePaymentForm= ({clientSecret, setClientSecret, setGoogleClientSecret, googleClientSecret, Package,
    Installment,
    setSuccess,
    EnrollmentData,
    PayPalButton,
    PaypalBtnRef,
    StudentImage,
    handleEnrollmentSuccess,
    UserInformation,
    dispatch,
    LatestLicense,
    setErr,
    Err,
    totalPayment}) => {
    const stripe = useStripe();
    const elements = useElements();
    const [loading, setLoading] = useState(false);
    const [paymentSuccess, setPaymentSuccess] = useState(false);
    const [error, setError] = useState("");
    const [paymentRequest, setPaymentRequest] = useState(null);

    const UserId = GetLocalStorage("UserInfo")?.UserId;
    console.log("UserId in CoursePaymentForm is:",UserId)
    console.log("totalPayment in CoursePaymentForm is:",totalPayment)


    const Dispatch = useDispatch();
    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("");
    const [showPopup, setShowPopup] = useState(false);
    const [paymentData, setPaymentData] = useState({
        paypal: { email: "", password: "" },
        "creditcard": {
        nameOnCard: "",
        cardNumber: "",
        expiryDate: "",
        securityCode: "",
        zipCode: "",
        },
        googlepay: { email: "", password: "" },
        applepay: { email: "", password: "" },
        "BankAccount": {
        bankName: "",
        accountHolderName: "",
        bankCode: "",
        branchCode: "",
        accountNumber: "",
        },
    });
    const Border = "border-[#E2E2E2] border-[1px] border-solid";

    const handlePaymentMethodChange = (e) => {
        if (!Installment) {
            setErr({ ...Err, PaymentTypeErr: "Please select payment type" });
            return;
        } else {
        setSelectedPaymentMethod(e.target.value);
        }
    };

    const handleInputChange = (method, field, value) => {
        setPaymentData((prevState) => ({
          ...prevState,
          [method]: {
            ...prevState[method],
            [field]: value,
          },
        }));
      };
    
    //   const handleSubmit = async () => {
    //     const dataToSend = {
    //       method: selectedPaymentMethod,
    //       details: paymentData[selectedPaymentMethod],
    //     };
    
    //     console.log("dataToSend at the backend is:",dataToSend)

    //     Dispatch(UpdateUserPaymentMethod(dataToSend,UserId))
    //       .then(() => {
    //         setShowPopup(true); // Show popup on successful update
    //       })
    //       .catch((error) => {
    //         console.error("Error updating settings:", error);
    //       });
    //   };

    // const handleSubmit = async (event) => {
    //     event.preventDefault();
    //     const { paymentIntent, error } = await fetch("http://localhost:5000/create-payment-intent", {
    //       method: "POST",
    //       headers: { "Content-Type": "application/json" },
    //       body: JSON.stringify({ amount: 50, currency: "usd" }),
    //     }).then((res) => res.json());
    
    //     if (error) {
    //       console.error(error);
    //       return;
    //     }
    
    //     const result = await stripe.confirmCardPayment(paymentIntent.clientSecret, {
    //       payment_method: { card: elements.getElement(CardElement) },
    //     });
    
    //     if (result.error) {
    //       console.error(result.error.message);
    //     } else {
    //       setPaymentSuccess(true);
    //     }
    //   };

    const handleCardPaymentSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setLoading(true);

        if (!stripe || !elements) {
            setError("Stripe is not properly initialized.");
            setLoading(false);
            return;
        }

        if (!clientSecret) {
            setError("clientSecret is not properly initialized.");
            setLoading(false);
            return;
        }

        const { error, paymentMethod } = await stripe.createPaymentMethod({
            type: "card",
            card: elements.getElement(CardElement),
        });

        if (error) {
            setError(error.message);
            setLoading(false);
            return;
        }
        // const TotalFee = Package?.TotalFee;
        // console.log("TotalFee before:",TotalFee)
        const TotalFee = totalPayment;
        console.log("totalPayment before:",totalPayment)
        console.log("TotalFee before:",TotalFee)

        // Send the payment method ID to the backend
        const response = await fetch(`${BaseUrl}/api/stripecardpayment`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ paymentMethodId: paymentMethod.id, TotalFee }),
        });

        const data = await response.json();
        console.log("data of card payment is:",data)

        const cardDetails = {
            brand: data.card.brand,
            exp_month: data.card.exp_month,
            exp_year: data.card.exp_year,
            last4: data.card.last4,
            postal_code: data.card?.postal_code,
        };
        console.log("cardDetails of card payment is:",cardDetails)

        if (data.error) {
            setError(data.error);
            setLoading(false);
            return;
        }

        // Confirm the payment
        const { paymentIntent, error: confirmError } = await stripe.confirmCardPayment(
            data.clientSecret
        );

        if (confirmError) {
            setError(confirmError.message);
        } else if (paymentIntent.status === "succeeded") {
            setPaymentSuccess(true);
             // ✅ Call ApproveOrder here after payment success
            await ApproveOrder(
                "1234",         // make sure this is returned by your backend if needed
                Package,
                Installment,
                EnrollmentData,
                handleEnrollmentSuccess,
                StudentImage,
                UserInformation,
                SetLocalStorage,
                dispatch,
                LatestLicense,
                UserId,
                selectedPaymentMethod,
                cardDetails,
                totalPayment
            );
        }

        setLoading(false);
    };

     // Fetch SetupIntent Client Secret
    //  const fetchSetupIntent = async (e) => {
    //     e.preventDefault();
    //     const response = await fetch("http://localhost:9100/api/banksetup-intent", {
    //         method: "POST",
    //         headers: { "Content-Type": "application/json" },
    //     });
    //     const data = await response.json();
    //     console.log("data intent is:",data)
    //     setClientSecret(data.clientSecret);
    // };

    // Handle Payment Submission
    const handleBankPayment = async (e) => {
        e.preventDefault();
        if (!stripe || !elements) return;
    
        const { paymentMethod, error } = await stripe.createPaymentMethod({
            type: "au_becs_debit",
            becs_debit: elements.getElement(PaymentElement),
            billing_details: {
                name: "John Doe", // Replace with actual user details
            },
        });
    
        if (error) {
            console.error("Error creating payment method:", error.message);
            return;
        }
    
        try {
            const response = await fetch(`${BaseUrl}/api/bankaccountpayment`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    paymentMethodId: paymentMethod.id,
                    amount: 1, // Replace with the actual amount
                }),
            });
    
            const data = await response.json();
    
            if (data.clientSecret) {
                console.log("Payment successful, client secret:", data.clientSecret);
                // alert("Payment successful!");
            } else {
                console.error("Error processing payment:", data.error);
            }
        } catch (err) {
            console.error("Payment failed:", err.message);
        }
    };

    //google and apple pay
    // useEffect(() => {
    //     if (!stripe) return;
    
    //     const pr = stripe.paymentRequest({
    //         country: "CA", // Canada
    //         currency: "cad", // Canadian dollars
    //         total: { label: "Total", amount: 5000 }, // $50.00 CAD
    //         requestPayerName: true,
    //         requestPayerEmail: true,
    //         paymentMethodTypes: ["card"], // Keep "card" for compatibility
    //     });
    
    //     console.log("pr is:", pr);
    
    //     pr.canMakePayment()
    //         .then((result) => {
    //             console.log("Google Pay / Apple Pay canMakePayment result:", result);
    //             if (result) {
    //                 setPaymentRequest(pr);
    //             } else {
    //                 console.warn("Google Pay / Apple Pay is not available");
    //             }
    //         })
    //         .catch((err) => {
    //             console.error("Error checking Google Pay / Apple Pay availability:", err);
    //         });
    
    // }, [stripe]);

    useEffect(() => {
        if (stripe) {
          const pr = stripe.paymentRequest({
            country: 'US',
            currency: 'usd',
            total: {
              label: 'Demo total',
              amount: 1099,
            },
            requestPayerName: true,
            requestPayerEmail: true,
          });

           // Check the availability of the Payment Request API.
            pr.canMakePayment().then(result => {
                if (result) {
                setPaymentRequest(pr);
                }
            });
        }

      }, [stripe]);
    

    // const createPaymentIntent = async (e) => {
    //     e.preventDefault();
    //     try {
    //         const response = await fetch("http://localhost:9100/api/create-googleandapplepayment-intent", {
    //             method: "POST",
    //             headers: { "Content-Type": "application/json" },
    //             body: JSON.stringify({ amount: 50 }), // 50 CAD
    //         });
    //         const data = await response.json();
    //         setGoogleClientSecret(data.clientSecret);
    //     } catch (error) {
    //         console.error("Error creating payment intent:", error);
    //     }
    // };

    const handlePayment = async () => {
        if (!stripe || !elements || !googleClientSecret) {
            console.error("Stripe.js has not loaded or no clientSecret available.");
            return;
        }
    
        const { paymentIntent, error } = await stripe.confirmPayment({
            clientSecret: googleClientSecret, // Use the clientSecret received from backend
            confirmParams: {
                return_url: "http://localhost:3000/success",
            },
        });
    
        if (error) {
            console.error("Payment Error:", error.message);
        } else {
            console.log("Payment Successful:", paymentIntent);
            alert("Payment Successful!");
        }
    };

    useEffect(() => {
        if (!stripe || !stripe.paymentMethods) return; // Ensure stripe is initialized
    
        const fetchPaymentMethods = async () => {
            try {
                const methods = await stripe.paymentMethods.list({
                    customer: "cus_xxx", // Replace with actual customer ID
                    type: "acss_debit",
                });
                console.log("Available Payment Methods:", methods);
            } catch (err) {
                console.error("Error fetching payment methods:", err);
            }
        };
    
        fetchPaymentMethods();
    }, [stripe]);
    
    
    return (
        <div className="w-full flex flex-col justify-center items-center gap-[10px]" >
            <div className=" w-[100%] lg:w-[70%] flex flex-col gap-[10px] bg-[#F8FAFA] rounded-[9px] px-[20px] py-[15px]">
                <p className="lg:hidden mb-[10px] text-[#404040] text-[20px] font-bold">Add Payment Mehod</p>
                <p className="text-[#000000] text-[18px] font-bold">Payment Method</p>
                <div className="mt-[10px] flex flex-col gap-[10px]">
                    <div className="w-full flex flex-col gap-[15px] px-[15px] py-[15px] bg-[#FFFFFF] rounded-[8px] shadow-[4px_5px_6px_#00000029] overflow-hidden"
                        style={{border:"1px solid #E8E8E8"}}>
                        <div className="w-full flex items-center justify-between">
                            <div>
                                <input
                                    type="radio"
                                    id="paypal"
                                    name="paymentMethod"
                                    value="paypal"
                                    onChange={handlePaymentMethodChange}
                                    className="mr-2"
                                />
                                <label htmlFor="paypal" className="text-[18px] text-[#707070]">
                                    PayPal
                                </label>
                            </div>
                            <div>
                                <img src={Paypal} alt="Paypal" className="h-[30px] w-[100px] object-contain" />
                            </div>
                        </div>
                        {selectedPaymentMethod === "paypal" && (
                            <div className="w-full flex justify-center items-center">
                                <div className="w-[50%]">
                                    <PaypalBtn
                                        handleEnrollmentSuccess={handleEnrollmentSuccess}
                                        setSuccess={setSuccess}
                                        Package={Package}
                                        Installment={Installment}
                                        PayPalButton={PayPalButton}
                                        PaypalBtnRef={PaypalBtnRef}
                                        EnrollmentData={EnrollmentData}
                                        StudentImage={StudentImage}
                                        LatestLicense={LatestLicense}
                                        currency="USD"
                                        setErr={setErr}
                                        Err={Err}
                                        UserInformation={UserInformation}
                                        dispatch={dispatch}
                                        selectedPaymentMethod={selectedPaymentMethod}
                                        totalPayment={totalPayment}
                                    />
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="w-full flex flex-col px-[15px] py-[15px] bg-[#FFFFFF] rounded-[8px] shadow-[4px_5px_6px_#00000029]"
                        style={{border:"1px solid #E8E8E8"}}>
                        <div className="w-full flex items-center justify-between">
                            <div>
                                <input
                                    type="radio"
                                    id="creditcard"
                                    name="paymentMethod"
                                    value="creditcard"
                                    onChange={handlePaymentMethodChange}
                                    className="mr-2"
                                />
                                <label htmlFor="Credit Card" className="text-[18px] text-[#707070]">
                                Credit Card / Debit Card
                                </label>
                            </div>
                            <div>
                                <img src={CreditCard} alt="CreditCard" />
                            </div>
                        </div>

                        {selectedPaymentMethod === "creditcard" && (
                            <>
                            <div className="w-full md:w-[70%] mx-auto">
                                    <CardElement
                                        options={{
                                            style: {
                                                base: {
                                                    fontSize: "18px",
                                                    padding: "10px",
                                                    color: "#424770",
                                                    backgroundColor: "white",
                                                    "::placeholder": { color: "#aab7c4" },
                                                },
                                                invalid: { color: "#9e2146" },
                                            },
                                        }}
                                    />
                                    <div className="w-full flex justify-end">
                                    <button disabled={!stripe || loading} className="bg-[#A1A3EF] p-3" style={{ marginTop: "10px" }} onClick={handleCardPaymentSubmit}>
                                        {loading ? "Processing..." : `Pay $${totalPayment}`}
                                    </button>
                                    </div>
                                    {error && <p style={{ color: "red" }}>{error}</p>}
                                    {paymentSuccess && <p style={{ color: "green" }}>Payment successful!</p>}
                            </div>
                           
                            {/* <div className="mt-[10px] flex flex-col gap-[10px]">
                                <input
                                    type="text"
                                    placeholder="Name on Card"
                                    value={paymentData.creditcard.nameOnCard}
                                    onChange={(e) =>
                                        handleInputChange("creditcard", "nameOnCard", e.target.value)
                                    }
                                    className={`w-full rounded-md text-[18px] py-2  px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] `}
                                />
                                <input
                                    type="text"
                                    placeholder="Card Number"
                                    value={paymentData.creditcard.cardNumber}
                                    onChange={(e) =>
                                        handleInputChange("creditcard", "cardNumber", e.target.value)
                                    }
                                    className={`w-full rounded-md text-[18px] py-2  px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] `}
                                />
                                <div className="flex gap-[20px]">
                                    <input
                                        type="text"
                                        placeholder="Expiry date (MM/YY)"
                                        value={paymentData.creditcard.expiryDate}
                                        onChange={(e) =>
                                            handleInputChange("creditcard", "expiryDate", e.target.value)
                                        }
                                        className={`w-[49%] rounded-md text-[18px] py-2  px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] `}
                                    />
                                    <input
                                        type="text"
                                        placeholder="Security Code"
                                        value={paymentData.creditcard.securityCode}
                                        onChange={(e) =>
                                            handleInputChange("creditcard", "securityCode", e.target.value)
                                        }
                                        className={`w-[49%] rounded-md text-[18px] py-2  px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] `}
                                    />
                                </div>
                                <input
                                    type="text"
                                    placeholder="Zip/Postal Code"
                                    value={paymentData.creditcard.zipCode}
                                    onChange={(e) =>
                                        handleInputChange("creditcard", "zipCode", e.target.value)
                                    }
                                    className={`w-full rounded-md text-[18px] py-2  px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] `}
                                />
                            </div> */}
                            </>
                        )}
                    </div>

                    <div className="w-full flex flex-col px-[15px] py-[15px] bg-[#FFFFFF] rounded-[8px] shadow-[4px_5px_6px_#00000029]"
                        style={{border:"1px solid #E8E8E8"}}>
                        <div className="w-full flex items-center justify-between">
                            <div>
                                <input
                                    type="radio"
                                    id="googlepay"
                                    name="paymentMethod"
                                    value="googlepay"
                                    onChange={handlePaymentMethodChange}
                                    className="mr-2"
                                />
                                <label htmlFor="Google Pay" className="text-[18px] text-[#707070]">
                                    Google Pay
                                </label>
                            </div>
                            <div>
                                <img src={GooglePay} alt="GooglePay" />
                            </div>
                        </div>
                        {selectedPaymentMethod === "googlepay" && (
                            <div className="mt-[10px] flex flex-col gap-[10px]">
                                <input
                                    type="email"
                                    placeholder="Email Address"
                                    value={paymentData.googlepay.email}
                                    onChange={(e) =>
                                        handleInputChange("googlepay", "email", e.target.value)
                                    }
                                    className={`w-full rounded-md text-[18px] py-2  px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] `}
                                />
                                <input
                                    type="password"
                                    placeholder="Password"
                                    value={paymentData.googlepay.password}
                                    onChange={(e) =>
                                        handleInputChange("googlepay", "password", e.target.value)
                                    }
                                    className={`w-full rounded-md text-[18px] py-2  px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] `}
                                />
                            </div>
                        )}
                    </div>

                    <div className="w-full flex flex-col px-[15px] py-[15px] bg-[#FFFFFF] rounded-[8px] shadow-[4px_5px_6px_#00000029]"
                        style={{border:"1px solid #E8E8E8"}}>
                        <div className="w-full flex items-center justify-between">
                            <div>
                                <input
                                    type="radio"
                                    id="applepay"
                                    name="paymentMethod"
                                    value="applepay"
                                    onChange={handlePaymentMethodChange}
                                    className="mr-2"
                                />
                                <label htmlFor="Apple Pay" className="text-[18px] text-[#707070]">
                                    Apple Pay
                                </label>
                            </div>
                            <div>
                                <img src={ApplePay} alt="ApplePay" className="h-[30px] w-[50px]" />
                            </div>
                        </div>
                        {selectedPaymentMethod === "applepay" && (
                            <div className="mt-[10px] flex flex-col gap-[10px]">
                                <input
                                    type="email"
                                    placeholder="Email Address"
                                    value={paymentData.applepay.email}
                                    onChange={(e) =>
                                        handleInputChange("applepay", "email", e.target.value)
                                    }
                                    className={`w-full rounded-md text-[18px] py-2  px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] `}
                                />
                                <input
                                    type="password"
                                    placeholder="Password"
                                    value={paymentData.applepay.password}
                                    onChange={(e) =>
                                        handleInputChange("applepay", "password", e.target.value)
                                    }
                                    className={`w-full rounded-md text-[18px] py-2  px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] `}
                                />
                            </div>
                        )}
                    </div>

                    <div className="w-full flex flex-col px-[15px] py-[15px] bg-[#FFFFFF] rounded-[8px] shadow-[4px_5px_6px_#00000029]"
                        style={{border:"1px solid #E8E8E8"}}>
                        <div className="w-full flex items-center justify-between">
                            <div>
                                <input
                                    type="radio"
                                    id="BankAccount"
                                    name="paymentMethod"
                                    value="BankAccount"
                                    onChange={handlePaymentMethodChange}
                                    className="mr-2"
                                />
                                <label htmlFor="Bank Account" className="text-[18px] text-[#707070]">
                                    Bank Account
                                </label>
                            </div>
                            <div>
                                <img src={BankTransfer} alt="BankTransfer" className="h-[30px]" />
                            </div>
                        </div>
                        {selectedPaymentMethod === "BankAccount" && (
                            <div className="mt-[10px] flex flex-col gap-[10px]">
                                <input
                                    type="text"
                                    placeholder="Bank Name"
                                    value={paymentData.BankAccount.bankName}
                                    onChange={(e) =>
                                        handleInputChange("BankAccount", "bankName", e.target.value)
                                    }
                                    className={`w-full rounded-md text-[18px] py-2  px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] `}
                                />
                                <input
                                    type="text"
                                    placeholder="Account Holder's Name"
                                    value={paymentData.BankAccount.accountHolderName}
                                    onChange={(e) =>
                                        handleInputChange("BankAccount", "accountHolderName", e.target.value)
                                    }
                                    className={`w-full rounded-md text-[18px] py-2  px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] `}
                                />
                                <div className="flex gap-[20px]">
                                    <input
                                        type="text"
                                        placeholder="Bank/Institute Code"
                                        value={paymentData.BankAccount.bankCode}
                                        onChange={(e) =>
                                            handleInputChange("BankAccount", "bankCode", e.target.value)
                                        }
                                        className={`w-[49%] rounded-md text-[18px] py-2  px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] `}
                                    />
                                    <input
                                        type="text"
                                        placeholder="Branch/Transition Code"
                                        value={paymentData.BankAccount.branchCode}
                                        onChange={(e) =>
                                            handleInputChange("BankAccount", "branchCode", e.target.value)
                                        }
                                        className={`w-[49%] rounded-md text-[18px] py-2  px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] `}
                                    />
                                </div>
                                <input
                                    type="text"
                                    placeholder="Account Number"
                                    value={paymentData.BankAccount.accountNumber}
                                    onChange={(e) =>
                                        handleInputChange("BankAccount", "accountNumber", e.target.value)
                                    }
                                    className={`w-full rounded-md text-[18px] py-2  px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] `}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>

           

            {/* <button onClick={fetchSetupIntent}>Link Bank Account</button> */}

            {/* {clientSecret && (
                <div >
                    <PaymentElement />
                    <button  disabled={!stripe} onClick={handleBankPayment}>Submit</button>
                </div>
            )} */}

            {/* Google Pay / Apple Pay */}
            {/* <div>
                {paymentRequest ? (
                    <PaymentRequestButtonElement options={{ paymentRequest }} />
                ) : (
                    <p>Google Pay / Apple Pay not available</p>
                )}
                <button onClick={handlePayment} disabled={!clientSecret}>
                    Pay with Stripe (CAD)
                </button>
            </div> */}

            {/* <div className="w-[100%] lg:w-[70%] flex justify-end gap-[20px] mt-[15px]">
                 
                <button
                    className="w-[300px] lg:w-[250px] h-[40px] rounded-[8px] bg-[#A1A3EF] text-[#FFFFFF] text-[18px]"
                    // onClick={handleSubmit}
                >
                    Confirm
                </button>
            </div> */}

        </div>
    );
};

export default CoursePaymentForm;
